import {SearchModel} from '../interfaces';

export function isEmpty(searchModel: SearchModel) {
    return (
        searchModel.searched.length + searchModel.original.length + searchModel.analogs.length === 0
    );
}
